import { useAuthContext } from "auth/AuthProvider";
import { logout } from "auth/tokenStorage";
import { Link } from "react-router-dom";
import Dropdown from "components/dropdown";
import avatar from "assets/img/avatars/avatarSimmmple.png";
import { useState } from "react";
import { PERMISSIONS } from "auth/permissions";
import { useTranslation } from "react-i18next";

export const UserDropdown = () => {
  const { t } = useTranslation();
  const { user, hasPermission } = useAuthContext();
  const [isOpenDropdown, setIsOpenDropDown] = useState(false);

  const userName = user?.name || user?.email?.split("@")[0] || t("common.user");
  const userEmail = user?.email;
  const currentOrg = user?.current_organization?.name || t("common.defaultOrganization");
  const currentWorkspace = user?.current_workspace?.name || t("common.mainWorkspace");

  return (
    <Dropdown
      setIsOpen={setIsOpenDropDown}
      isOpen={isOpenDropdown}
      button={
        <div className=" flex w-max cursor-pointer items-center gap-3 rounded-lg p-2 transition-colors duration-200    ">
          <div className="relative">
            <img
              className="h-10 w-10 rounded-full border-2 border-white shadow-sm dark:border-navy-700"
              src={avatar}
              alt={userName}
            />
          </div>
        </div>
      }
      children={
        <div className="flex w-64 flex-col overflow-hidden rounded-xl border border-gray-100 bg-white shadow-xl dark:border-navy-600 dark:bg-navy-700">
          <div className="ml-4 mt-3 py-3">
            <div className="flex items-center gap-2">
              <p className="text-sm font-bold text-navy-700 dark:text-white">
                👋 {t("navbar.hey")}, {userEmail}
              </p>
            </div>
          </div>

          {/* <div className="py-2">

            <div className="my-2 border-t border-gray-100 dark:border-navy-600"></div>

            <Link
              to="/dashboard/corganization"
              onClick={() => setIsOpenDropDown(false)}
              className="flex items-center justify-between px-4 py-2 text-sm text-gray-700 transition-colors duration-150 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-navy-600"
            >
              <div className="flex items-center gap-3">
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
                <div className="min-w-0 flex-1">
                  <span className="block truncate">Organisation Settings</span>
                  <span className="block truncate text-xs text-gray-500 dark:text-gray-400">
                    {currentOrg}
                  </span>
                </div>
              </div>
            </Link>

            <Link
              onClick={() => setIsOpenDropDown(false)}
              to="/dashboard/cworkspace"
              className="flex items-center justify-between px-4 py-2 text-sm text-gray-700 transition-colors duration-150 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-navy-600"
            >
              <div className="flex items-center gap-3">
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 5a2 2 0 012-2h4a2 2 0 012 2v2H8V5z"
                  />
                </svg>
                <div className="min-w-0 flex-1">
                  <span className="block truncate">Workspace Settings</span>
                  <span className="block truncate text-xs text-gray-500 dark:text-gray-400">
                    {currentWorkspace}
                  </span>
                </div>
              </div>
            </Link>
          </div> */}

          <div className="border-t border-gray-100 py-2 dark:border-navy-600">
            <Link
              onClick={() => setIsOpenDropDown(false)}
              to="/dashboard/profile"
              className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 transition-colors duration-150  dark:text-gray-200"
            >
              <svg
                className="h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
              {t("navbar.profileSettings")}
            </Link>
            {(hasPermission(PERMISSIONS.SUPER_ADMIN) ||
              hasPermission(PERMISSIONS.ACCESS_MODEL_MANAGEMENT)) && (
              <Link
                onClick={() => setIsOpenDropDown(false)}
                to="/dashboard/organization-settings"
                className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 transition-colors duration-150  dark:text-gray-200"
              >
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
                {t("navbar.organizationSettings")}
              </Link>
            )}
            <Link
              onClick={() => setIsOpenDropDown(false)}
              to="/dashboard/usage-overview"
              className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 transition-colors duration-150  dark:text-gray-200"
            >
              <svg
                className="h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
              {t("navbar.usageOverview")}
            </Link>
            {hasPermission(PERMISSIONS.SUPER_ADMIN) && (
              <Link
                onClick={() => setIsOpenDropDown(false)}
                to="/dashboard/global-settings"
                className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 transition-colors duration-150  dark:text-gray-200"
              >
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                {t("navbar.globalSettings")}
              </Link>
            )}
            <button
              onClick={() => {
                setIsOpenDropDown(false);
                logout();
              }}
              className="flex w-full items-center gap-3 px-4 py-2 text-sm text-red-600 transition-colors duration-150   dark:text-red-400  "
            >
              <svg
                className="h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              {t("navbar.logout")}
            </button>
          </div>
        </div>
      }
      classNames={"py-2 top-12  w-max right-2"}
    />
  );
};
